import { FORTRESS_CREATE_REPORTS } from 'src/app/reporting/services/ReportingServiceConstants';
import { Policy } from './Policy';
import { PolicyElement } from './PolicyElement';

export class CreateReportsPolicy extends Policy {
  override readonly keyStart = new RegExp(`^${FORTRESS_CREATE_REPORTS}\\.`);

  detailByIwsClient = new PolicyElement('DETAIL BY IWS CLIENT');
  detailCorrespondent = new PolicyElement('DETAIL CORRESPONDENT');
  detailedCusip = new PolicyElement('DETAILED CUSIP');
  detailedCusipInt = new PolicyElement('DETAILED CUSIP INT');
  nationalFinancialBranchListing = new PolicyElement(
    'NATIONAL FINANCIAL BRANCH LISTING',
  );
  omnibusCertification = new PolicyElement('OMNIBUS CERTIFICATION');
  platformEtfActivity = new PolicyElement('PLATFORM ETF ACTIVITY');
  redemptionFee = new PolicyElement('REDEMPTION FEE');
  stateLevelSales = new PolicyElement('STATE LEVEL SALES');
  wiPlanActivity = new PolicyElement('WI PLAN ACTIVITY');

  constructor() {
    super();
    this.policyElements.push(
      this.detailByIwsClient,
      this.detailCorrespondent,
      this.detailedCusip,
      this.detailedCusipInt,
      this.nationalFinancialBranchListing,
      this.omnibusCertification,
      this.platformEtfActivity,
      this.redemptionFee,
      this.stateLevelSales,
      this.wiPlanActivity,
    );
  }
}
